import es from "./locales/es";
import en from "./locales/en";
import fr from "./locales/fr";
import de from "./locales/de";
import it from "./locales/it";
import pt from "./locales/pt";
import nl from "./locales/nl";
import pl from "./locales/pl";
import ro from "./locales/ro";
import sv from "./locales/sv";
import da from "./locales/da";
import no from "./locales/no";

// Adding a language = drop a new locale file + register it here.
// Components never change.
export const translations = { es, en, fr, de, it, pt, nl, pl, ro, sv, da, no };
